export enum DigitalizationFormalControlStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  ACCEPTED_WITH_REMARKS = 'acceptedWithRemarks',
  WAITING = 'waiting',
  WAITING_FOR_METADATA_CHECK = 'waitingForMetadataCheck',
}
